import styled from 'styled-components'
import Wrapper from 'common/wrapper'
import { Typography } from 'common/typography'

const ScholarshipRulesStyled = styled.section`
  padding-block-start: 40px;
  padding-block-end: 40px;
  h3, p {
    margin-block-end: 16px;
  }
  .icon {
    font: var(--headline2);
    margin-block-end: 16px;
  }
  .rules {
    margin-block-end: 40px;
  }
  @media(min-width: 768px) {
    padding-block-end: 80px;
    .icon {
      font: var(--headline1);
    }
  }
`

function ScholarshipRules() {
  return (
    <ScholarshipRulesStyled aria-labelledby="rules">
      <Wrapper maxWidth="600">
        <div className="rules">
          <span className="icon" role="img" aria-label="rules icon">🤝</span>
          <Typography as="h3" id="rules" small="headline5" large="headline4" color="var(--baseNeutral)">
            Reglas para obtener la beca
          </Typography>
          <p>
            Tendrás 3 semanas desde que te demos el acceso para terminar el curso y sigas participando por ganarte el acceso al siguiente.
          </p>
          <p>
            <b>Por ejemplo: </b>
            una vez te inscribes al Curso de Figma para Frontends tienes 2 semanas para terminarlo y ganar tu acceso al Taller: Portafolio Jaume.
            Funciona de la misma forma con los siguientes cursos.
          </p>
        </div>
        <div className="rules">
          <span className="icon" role="img" aria-label="alert icon">🛑</span>
          <Typography as="h3" small="headline5" large="headline4" color="var(--baseNeutral)">
            Disclaimer
          </Typography>
          <p>Estos premios están sujetos a cambios sin previo aviso.</p>
        </div>
      </Wrapper>
    </ScholarshipRulesStyled>
  )
}

export default ScholarshipRules
